import { render, staticRenderFns } from "./POSTransactions.vue?vue&type=template&id=8b1bed4e"
import script from "./POSTransactions.vue?vue&type=script&lang=js"
export * from "./POSTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports